import BaseApi from "./base";

class NotificacionesApi extends BaseApi {
  constructor() {
    super("notificaciones");
  }

  update(id, data) {
    return this.request.patch(`/notificaciones/${id}`, data);
  }
}

export default new NotificacionesApi();
